import React from 'react';
import PropTypes from 'prop-types';
import { useAlertContext } from './AlertContext';
import Alert from '../Alert';
import styles from './AlertContainer.module.scss';

const defaultTranslateAlertInfoText = (totalAlertsShown, totalAlerts) =>
  `Showing ${totalAlertsShown} of ${totalAlerts} alerts`;

export const AlertContainer = ({
  containerId = 'base',
  limit,
  shouldShowAlertInfoText = true,
  translateAlertInfoText = defaultTranslateAlertInfoText
}) => {
  const { alerts, hideAlert } = useAlertContext();

  const handleOnClose = (id) => {
    hideAlert(id);
  };

  const filterLimit = (_, index) => !limit || index < limit;
  const filterContainer = (alert) => alert?.containerId === containerId;

  const totalAlerts = alerts.filter(filterContainer).length;
  const totalAlertsShown = alerts
    .filter(filterContainer)
    .filter(filterLimit).length;

  return (
    <>
      {alerts
        .filter(filterContainer)
        .filter(filterLimit)
        .map(
          ({
            alertType,
            id,
            content,
            containerId: containerIdProp,
            ...rest
          }) => (
            <Alert
              alertType={alertType}
              key={id}
              id={id}
              {...rest}
              onClose={() => handleOnClose(id)}
            >
              {content}
            </Alert>
          )
        )}
      {shouldShowAlertInfoText && totalAlerts > totalAlertsShown && (
        <div
          className={styles.alertContainerInfoContainer}
          data-testid="alert-info"
        >
          <div className={styles.alertContainerInfo}>
            {translateAlertInfoText(totalAlertsShown, totalAlerts)}
          </div>
        </div>
      )}
    </>
  );
};

AlertContainer.defaultProps = {
  containerId: 'base',
  limit: undefined,
  shouldShowAlertInfoText: true,
  translateAlertInfoText: defaultTranslateAlertInfoText
};

AlertContainer.propTypes = {
  containerId: PropTypes.string,
  limit: PropTypes.number,
  shouldShowAlertInfoText: PropTypes.bool,
  translateAlertInfoText: PropTypes.func
};

export default AlertContainer;
